// Application specific configuration variables
// potentially sourced from process.env.REACT_APP_*
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// console.log("### Base URL", API_BASE_URL);

export const DEBUG = process.env.REACT_APP_DEBUG === "true";

export const LOCALE = "de";
export const CURRENCY = "EUR";
export const CURRENCY_DECIMAL_SEPARATOR = ",";
export const CURRENCY_THOUSANDS_SEPARATOR = ".";



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/config.ts